import { gsap, lenis } from '../global/gsap';

const initBackLink = (element) => {
    const currentDomain = window.location.hostname;

    if (document.referrer && document.referrer.includes(currentDomain)) {
        element.classList.add('is-active');

        element.addEventListener('click', (event) => {
            event.preventDefault();
            history.back();
        });
    }

    let expandedWidth = element.offsetWidth;
    let collapsedWidth = element.offsetHeight;
    let scrollThreshold = window.innerHeight / 2;

    const isCollapsed = () => element.classList.contains('scrolled');

    const remeasure = () => {
        const wasCollapsed = isCollapsed();
        element.style.width = '';
        expandedWidth = element.offsetWidth;
        collapsedWidth = element.offsetHeight;
        scrollThreshold = window.innerHeight / 2;
        gsap.set(element, { width: wasCollapsed ? collapsedWidth : expandedWidth });
    };

    const expand = () => {
        if (!isCollapsed()) return;
        element.classList.remove('scrolled');
        gsap.to(element, { width: expandedWidth, duration: 0.25, ease: 'power2' });
    };

    const collapse = () => {
        if (isCollapsed()) return;
        element.classList.add('scrolled');
        gsap.to(element, { width: collapsedWidth, duration: 0.25, ease: 'power2' });
    };

    window.addEventListener('resize', remeasure);

    lenis.on('scroll', ({ scroll }) => {
        if (scroll > scrollThreshold) {
            collapse();
        } else {
            expand();
        }
    });
};

export { initBackLink as default };
